import { render } from "./LotteryForm.vue?vue&type=template&id=5a15c73e"
import script from "./LotteryForm.vue?vue&type=script&lang=js"
export * from "./LotteryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__